module.exports = __webpack_public_path__ + "img/IMG20190716191611.37e75f5f.jpg";